<template>
  <v-dialog class="vb-dialog vb-dialog-danger" v-model="authStore.sessionInvalidatedDialogVisible" max-width="520" persistent>
    <v-card>
      <v-card-title class="pa-3">
        <v-icon class="mr-3" size="28">mdi-alert</v-icon>
        {{ $t('account.sessionInvalidatedTitle') }}
      </v-card-title>

      <v-card-text class="text-body-1">
        {{ $t('account.sessionInvalidatedMessage') }}
      </v-card-text>

      <v-card-actions class="justify-end">
        <v-btn color="primary" variant="flat" @click="confirmLogout">
          {{ $t('account.sessionInvalidatedAction') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { useAuthStore } from '@/stores/AuthStore.js'

export default {
  name: 'SessionInvalidatedDialog',
  computed: {
    authStore: function() {
      return useAuthStore();
    },
  },
  methods: {
    confirmLogout: function() {
      this.authStore.confirmSessionInvalidatedLogout(this.$router);
    },
  },
}
</script>
